export enum PortalMaterialOrderStatusEnum {
    NEW = 'new',
    PROCESSING = 'processing',
    SHIPPED = 'shipped',
    DONE = 'done',
    CANCELED = 'canceled',
}
